module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "مَظاهِرُ-الكَون"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مَظاهِرُ الكَون")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إِنَّ الجَمالَ البَادِي على وجوهِ الأَشياءِ في هذا الكون مُستَمِرٌّ، ولا بُدَّ مِن أنَّ الحقيقةَ الأبديَّة المُطْلَقة تكمُنُ في داخلِ هذهِ السُّطوح والقُشور المرئيَّة مِن مَظاهر الكَون، والبحثُ عن أسرارِ الكون كذلك مستَمِرٌ بدوافعَ وأدواتٍ عِلمية إضافةً لدوافع الإنسانِ وفضولِه الفِطري لتحقيقِ الأَهداف التي تضمَن تيسيرَ العيشِ، وتُسهِمُ في تحقيقِ الرفاهيَّة للبشرية، وفيها توفيرٌ للوقتِ والجهد، وقد تُمَكِّنُ مِن القَفزِ عن مساراتٍ علمية حاليَّة جاريَة مِن خلالِ اكتشافاتٍ يُستَدَلُّ بها، وتُغنِي عن انتظارِ النتائج المستقبلية المتوقَّعة للأبحاثِ العلمية.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لكن عند استعراضِ العلوم التي نجحَ المختصُّونَ مِن علماءِ الفضاءِ والجيولوجيا في التوَصُّلِ إِليها، نجِد أنَّها في مُجْملها لَم تتَعَدَّ طَورَها النظري بَعْدُ، وكلُّ ما فيها يشيرُ إلى أنَّ الكونَ المُدْرَكَ والمَعروف ما هوَ إلَّا جزءٌ مِن الكَون الفِعلِي، وأنَّ الكونَ الحقيقي قد يكونُ أكبرَ مِن الكونِ المَرْصودِ علمياً بمئاتِ أو ملياراتِ المَرّات، كمَا لَم يَأتِ أَحَدٌ بما يُشيرُ إلى أَنَّ للكَونِ حُدوداً؛ لأَنَّ مثلَ هذا القَوْل يتَطَلَّبُ الإجابةَ على سؤالِ: \"ماذا يوجدُ بعدَ تلكَ الحُدود؟\"")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وكيفَ لنا توقُّع تَوَفُّرِ تصَوُّر شامِل ومعلوماتٍ حاسِمة عن الكَون في الوقتِ الذي لَم تكتَمِل لنا فيه معرفَةُ حتى الصورَة الفِعلِية التي هي عليها مكوِّناتُ وطبقاتُ الأرضِ التي نعيشُ عليها، حيثُ إنَّ مُجْمَلَ معرفتِنا العلمية الحَقيقية عنها لا تتعدَّى حدودَ قِشرَتِها البالغِ سمْكُها مِن ٣٠ إلى ٦٠ كيلو متراً، وكلُّ ما زادَ عن ذلك ما زالَ يدخلُ في طَورِ العلومِ النظرية، خاصَّةً ما تعلَّقَ بمَركَزِها الضارِبِ في العُمق والذي يَبعُدُ عن سطحِها الذي نتَنَقَّلُ عليه 6371 كيلو متراً")]), _vm._v(" }"), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ما يعادل رحلة سبع ساعاتِ سَفَرٍ بسرعةِ الطائراتِ المدنية")]), _vm._v("{ "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأمر الذي لا يتركُ مجالاً حتى للتفكير في طريقةٍ لمُلامَسَة هذه الأَعماق السَّحيقَة، فلَم يتعَدَّ أَعمقُ حَفْرٍ في قِشرتِها تمَكَّنَ الإنسانُ من بُلوغِهِ وأنجِزَ في روسيا ١")]), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("٢ كيلو متراً، حيث وصلَت درجةُ الحرارةِ الناتجةِ عن الحَفرِ إلى ٣٠٠ درجة مئوية، وكانَ من الصعوبةِ بمَكان إيجادُ معادنَ وأدواتِ حَفرٍ أكثرُ قدرةً على التحمُّلِ للمضِي قُدُماً في الحَفرِ إلى أَبعَدَ من ذلكَ، إضافة إلى أَنَّ تَكرارَ انهيارِ الحَفْر على هذا العمق لِضَعْف الصخور وبَدْءِ ذَوَبانها أدَّى إلى إنهاءِ المشروع وإغلاقِه، وبذلكَ أُسْدِلَ السِّتَار على مُهِمَّةٍ بَدَت وكأَنّها مُستَحيلة، وقد مضَى على ذلكَ نحوُ خمسينَ عاماً، ولَم يُعِدْ أَحدٌ مُنذُ ذلك الوقت تَكرارَ المحاوَلَة لعدَمِ جَدواها")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بما توفَّرَ مِن إمكاناتٍ علمية آنِيَّة، وفي انتظارِ مزيدٍ من التطوُّرِ العِلمي لتجاوزِ التَّحدِّياتِ التقَنِيَّة والفَنيّة الراهِنَة لمثل هذه المحاولاتِ والأبحاث.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("والنَّفَاذُ إلى أبْعَدَ من ذلك كَمَا في كلِّ اكتشافٍ عِلمِي بحاجةٍ إلى سُلطانٍ منَ اللهِ وإِذْنِه، وقد رَأَيْنا كيف أَنَّ بعضَ الاكتشافاتِ ألحَقَت أيضاً بالإنسانِ ضَرَراً جرَّاءَ سوءِ استخدامِ ما نتَجَ عنها واستغلالها مِن قِبَلِ آخرين لتحقيقِ أهدافٍ بعيدةٍ عن منفعَةِ البشرية، قالَ تعالى:")])]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('strong', [_vm._v("﴿يَا مَعْشَرَ الْجِنِّ وَالْإِنسِ إِنِ اسْتَطَعْتُمْ أَن تَنفُذُوا مِنْ أَقْطَارِ السَّمَوَاتِ وَالْأَرْضِ فَانفُذُوا لَا تَنفُذُونَ إِلَّا بِسُلْطَانٍ")]), _vm._v("﴾")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الآية")]), _vm._v(" ["), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("33")]), _vm._v("] "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("من سورَةِ الرحمن")])]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ورُغْمَ كلِّ القفَزاتِ العلميةِ النوعية التي تحقَّقَت على الأرض في شتَّى العلوم الحياتِية واستمرارِ الكثيرِ مِن الدراسات المُثيرَة والبُحوثِ الواعِدَة الجَديرَة بالتقديرِ والاهتمام، وخاصَّةً ما تعلَّقَ منها بعلومِ الرَّصد والاتصالات، إِلَّا أنَّها عجزَت عن مُلامسَةِ أو تسجيلِ أيّ إشاراتٍ لحقائق كثيرة هامَّة نؤمنُ بها، كالرُّوحِ والملائكة المكَرَّمين، أو لكائناتٍ حيَّةٍ أخرَى تَقْطُنُ كوكبَ الأرض، وعندنا – نحنُ المسلمين – بها الخبرَ اليَقين، كالجِنِّ، أو قومِ يأجوجَ ومَأجوج، فَلَم تُقَدِّمْ لنا شيئاً عن ذلك ولا عن غيرِها مِن كثيرٍ مِن حقائق قائِمَة، لكنها ما زالت مجهولة على صعيدِ الاكتشافات والعلوم الحياتية التي تمَّ التَّوَصُّلُ إليها مِن خلالِ البحوثِ والتجارِب حسبَما اقتَضَتهُ متَطَلبات تسيير شؤونِ الحياة البشريَّة على هذهِ الأرض، وَوَفقاً لاحتياجات استخدام تطبيقاتِها، وقد لا تُسْعِفُ على كوكَبٍ آخَرَ، ممَّا يؤكِّدُ بما لا يَدَعُ مجالاً للشَّكِ أنَّ ما نَدورُ بفَلَكِهِ ونعيشهُ من علومٍ واكتشافات ما هو إلَّا جُزئِيَّة عِلميَّة في حدودِ ما أَذِنَ اللهُ بِهِ في هذه المرحَلة من حياة البشرية، وأنَّ هناكَ سَقفاً لكلِّ التوقُّعات والاكتشافاتِ المستقبلية مِن حقائِقِ الوُجود تحدِّدُه دائماً طبيعةُ الإنسانِ وحُدودُ إمكاناتِ الإدراك التي أرادَها الخالقُ جَلَّ جَلالُه لنا، بيدِهِ مقاليدُ السمواتِ والأرض، وهو العليم الخبير.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فقد حدَّدَ سبحانهُ وتعالى للإنسانِ سَمْعَهُ بتردُّداتٍ مُعيَّنَة، وبَصَرَهُ برؤيةِ أطوالٍ مَوجِيَّة من الطيفِ الضوئي محَدَّدَةٍ أيضاً تُلَبِّي احتياجاتَنا، وتمكِّنُنَا مِن عيشِ الحياةِ بلا ضرَرٍ ولا ضِرار،")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وَكانَ دائماً لا بُدَّ مِن الوَحي السَّماوي عبرَ العُصور لاطِّلاع الإنسان على الحقيقة المُطلَقَة، حيثُ إنَّ العقلَ والخَيالَ العِلمي وكافَّة البحوث والدراسات العلمية تبقى مرتبطَةً بالواقِعِ المَحسوسِ والمشاهَدات، فلا تَرقَى يوماً إلى الشُمولِيَّة المطْلَقة، ويبقى المجهولُ هو العاملُ الحاسِم الذي يتحكَّمُ في النتائجِ بعيداً عن التوقُّعات.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لذلك كانت آياتُ القرآنِ العظيم وكلُّ ما جاءَ بهِ الوَحي دائماً هُم المصداقيَّة الوَحيدَة للوَصْفِ الصحيح للقَضايا الأساسيّة ومنها الكونُ والحياةُ الآخرَة، وما زالَت هي كذلك مُنذُ بِعثَةِ سيدنا محمد عليه أفضلُ الصلاةِ والسلام، وتُبقِينا دائِماً على موعدٍ معَ معانٍ وعلومَ جديدة مهما طالتِ بِنا الأيامُ، وكذلكَ سنَكون مع ما جاءَت به الرسالاتُ السماوية عن أخبارِ ما بَعْدَ البَعثِ ما دامَت الآخِرَة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("آخذِينَ في الاعتبار أنَّ الظلامَ والزَّمهَرير كليهِما ونَقيضَيْهِمَا الضوءُ والحرارة أياً وُجِدَ مِنها أولاً كلُّها تحتاجُ خالِقاً لإيجادِها، ولا تأتي مِن العَدَم، فإنَّهُ خارجَ النجومِ والكواكبِ المضاءَة يَعُمُّ الكونَ ويَسودُهُ الظلامُ التَّامُّ، إِذ إنَّ سَماكةَ الطبقةِ المُضاءَة نهاراً مِن غلافِ الأرض الجَوِّي نتيجةً لانعِكاسِ ضوءِ الشمسِ عن الأشياء وتشَتُّتِهِ لا تتَجاوَزُ ٢")]), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("٠٠ كيلو متر، يدخلُ بعدَها ظلامُ الكونِ الدَّامِسِ لِمَن أرادَ أَن يتعدَّى هذه المسافةِ البسيطةِ نسبياً والتي لا تزيدُ عن البُعد بين مَدينتين داخلَ حدودِ الدولةِ الواحدة، وتِلكَ ميزَةٌ اختَصَّ بِها سبحانهُ وتعالى الأرضَ عن غيرِها من الكواكِب، حيث إنَّ إضاءَةَ النجومِ لمَا حولَها من كواكب تكونُ أبسطَ من ذلكَ ولا تسمَّى نَهاراً.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وإذا كانت كتلَةُ الجزءِ المعلوم لنا من الكونِ والتي تَشمَلُ كافَّة الأجرام السماويّة تعادِلُ ٢")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إلى ٣٪ من إجمالي كتلةِ الكون، فرُبَّمَا تكونُ كتلةُ الكونِ الرئيسة المُتبقِيَة تكْمُنُ في المادةِ السوداءِ المُظْلِمَة التي تسبحُ فيها الأجرامُ السَّمَاويّة والقُوى الناتِجة عن وظيفَتِها، أو في شيءٍ آخَرَ لَم يتِمَّ التوصُّلُ إِليهِ بَعْد، ويُنتَظَرُ من كثيرٍ من دراساتِ المختَصّينَ الجَارِيَة على طبيعةِ هذه المادة المُظْلِمَة المساعَدة في تقديم إِجاباتٍ عن ذلك وفي وضعِ اليَّدِ على المَزيد من خيوطِ الفَهم لمَا يحيطُ بنا في محاولَةٍ للوُصولِ لشيءٍ مَا مِنَ التَّصوُّرِ لتلكَ الأحداثِ الغَيبِيّة المُوغِلَة في التاريخ الكَونِي، ممَّا يُسهِمُ في توسيعِ إمكاناتِ الفَهمِ البشرية المستقبلية لحقيقةِ الكَون، ونحنُ نسأَلُ الله أنْ ينعكسَ ذلكَ إيجاباً على ما ينفَعُ البشَريَّة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("والمادَة المظلِمةُ موجودَةٌ، وتعتَبَرُ اللُّغزَ العِلمي لهذا العَصر، وهي مادة مُراوِغَة لَم يُفلِح أحدٌ بَعدُ في التَّعرُّفِ على ماهِيَّتِها، وكذلك الطاقةُ المظلمة المصاحبَة لها وتأثيراتُها التجاذُبيَّة في حفظِ التباعُدِ بينَ الأجرامِ السماوية، إلَّا إنَّها حقيقةٌ قائمة مصداقاً لقولِ اللهِ تعالى:")])]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("﴿"), _c('strong', [_vm._v("وَكُلٌّ فِي فَلَكٍ يَسْبَحُونَ")]), _vm._v("﴾")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الآية")]), _vm._v(" ["), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("40")]), _vm._v("] "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("من سورة يس")])]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ويَعتقِدُ العلماءُ أنَّها مادة شفَّافة، وقد ثبَتَ لهم أنَّها لا تعكِسُ الضوء، فيَمُرُّ من خلالِها دونَ أنْ يطرَأَ أي تغييرٍ في طبيعتِه أو على اتجَاهِهِ، وهذا قولٌ لا يتعارَضُ مع ما نعرفُهُ عن قدرَةِ الملائكة وقد خَلَقَهُم اللهُ سبحانه وتعالى مِن نُورٍ على النَّفَاذِ منها والمرورِ من خلالِها مهما كانت شِدَّةُ صلابَتِها أثناء تَنَقُّلِهِم في أقطارِ السمواتِ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وحيثُ إنَّهُ لا بدَّ للسباحةِ مِن وسطٍ تتِمُّ خِلالَهُ استناداً لما هوَ الحالُ في كثيرٍ من ظواهِرَ مماثِلَة ومعلومَة لنا في الكَون، كمَا في سباحةِ السُّفُنِ والأسماكِ في مياهِ البِحار، وكذلك في تحليقِ الطائراتِ ومختلفِ أَنواعِ الطيورِ في الهواء، فإنَّ لِلمَلائكةِ أجنحَةً، والأجنحةُ إنَّما تُستخدَمُ للتَّحليقِ والانتقالِ باستِخدامِ وسطٍ ما، قد يكونُ ذلك هو ما يُسمَّى بالمادةِ السوداء التي تملأُ الكونَ، وحيث إنَّ التحليقَ في مجالِ الغِلاف الجَوي الأرضي يحتاجُ وَسَطاً كثيفاً نسبياً كالهواء للتغلُّبِ على الجاذبية الأرضية، إلَّا أَنهُ في الفضاء حيث انعِدامُ الجاذبية، فقد يَكفي أنْ يكونَ الوسَطُ الحامِلُ أثناءَ التحليقِ بسيطَ الكثافةِ ومشابهاً في كثافتِهِ لما يُطلَقُ عليه هنا المادة السوداء التي تسبَحُ فيها كافَّةُ الكواكبِ والنجوم والأجرامِ السماوية.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('strong', [_vm._v("و")]), _vm._v("سبحانَ الذي أَتقَنَ كلَّ شيءٍ خَلَقَه، قال تعالى:")])]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("﴿"), _c('strong', [_vm._v("وَالسَّمَاءَ بَنَيْنَاهَا بِأَيْدٍ وَإِنَّا لَمُوسِعُونَ")]), _vm._v("﴾")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الآية [47] من سورة الذاريات")])]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وقد اتَّفَقَت مختلَفُ النظرياتِ العلمِية على أن استمرارَ توسُّعِ الكونِ")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بمعدلاتٍ فائِقَة الدِّقة يُؤَدِي إلى تَبريدِه، ويكفلُ دَوَام تباعُدِ أَجرَامِه وحفظِ بِنائِهِ من الانهِيار.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فتَسييرُ الكَونِ فوق مستوى إدراكِ البَشَر، وكلُّ ما في الكونِ يشهَدُ للهِ وحدَهُ بالتفَرُّدِ والوَحدانِيَّة المُطلَقَة فوقَ كافةِ خلقِهِ بغيرِ شبيهٍ ولا شريكٍ ولا مُنَازِع، وفيهِ الاستِدلالُ على حقيقَةِ الألوهِيَّة والوَحدانيَّة وحَتمِيَّة البَعثِ والحَشرِ بعدَ النُّشور .")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وقد جاءَ في القرآن العظيم أَنَّ مُجْرَياتِ ووقائِع الحياة ستُؤَكدُ للبشريّة أهميَّة وضرورَة ما جاءَ به الإِسلام تصديقاً لقولِه تعالى:")])]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("﴿"), _c('strong', [_vm._v("سَنُرِيهِمْ آَيَاتِنَا فِي الْآفَاقِ وَفِي أَنفُسِهِمْ حَتَّى يَتَبَيَّنَ لَهُمْ أَنَّهُ الْحَقُّ")]), _vm._v("﴾")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الآية")]), _vm._v(" ["), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("53")]), _vm._v("] "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("من سورَةِ فصِّلَت")])]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ومِن ذلك نَجِد أَنَّ أَرقَى ما توصَّلَ إِليهِ الفلاسفةُ الغربيون المجتهدون من الحقائِق يتَّفِقُ معَ الفِطرَةِ وفي وجوهٍ لا حصْرَ لها مع تعاليم الدين الإسلامي، حيثُ خَلُصَت الكثيرُ من الدراساتِ الغربية ذاتِ النَّهْج التّجريبي السَّليم إلى نتائِجَ كثيرةٍ مماثِلَة، ممَّا يؤَكدُ سَبْقَ الإِسلامِ لها بقرونٍ في التَّمهيدِ للفهمِ الصحيحِ للكَونِ وفي توفيرِ المَعرفَة الرُّوحِيَّة، ومَلْء النَّفْس البشَرِية بالطُّمَأنينَة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a2cea7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch007.vue
// module id = 78
// module chunks = 0